/**************************************************
 * Nombre:       Formulario_Lead_Comentarios.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Lead_Comentario_Comentario from "./Formulario_Lead_Comentario_Comentario";
import Tarjetas_Comentarios from "../Tarjetas/Tarjetas_Comentarios";

const Formulario_Lead_Comentarios = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Comentario',
        dato: 'comentarios',
        Formulario: Formulario_Lead_Comentario_Comentario,
        Tarjeta: Tarjetas_Comentarios
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )


}
export default Formulario_Lead_Comentarios